<template>
  <div class="slider">
    <template v-if="route_type == '/service'">
      <div class="menu_item">
        <router-link
          :to="{ path: route_type + '/v2/downloads' }"
          :class="['menu_item_single','menu_item_right', platform == 'downloads' ? 'act' : '']"
        >
          <div class="menu_icon icon_yjbg"></div>
          <div class="menu_text">研究报告</div>
        </router-link>
      </div>
      <!-- <div class="menu_item">
        <router-link
          :to="{ path: route_type + '/v2/sales/list' }"
          :class="['menu_item_single','menu_item_right', platform == 'sales' ? 'act' : '']"
        >
          <div class="menu_icon icon_xlph"></div>
          <div class="menu_text">销量排行</div>
        </router-link>
      </div> -->
      <!-- <div class="menu_item">
        <router-link
          :to="{ path: route_type + '/v2/ota/index' }"
          :class="['menu_item_single','menu_item_right', platform == 'ota' ? 'act' : '']"
        >
          <div class="menu_icon icon_ota"></div>
          <div class="menu_text">OTA</div>
        </router-link>
      </div> -->
    </template>
    <template v-else>
      <div class="menu_item">
        <router-link
          :to="{ path: route_type + '/v2/rank/0' }"
          class="menu_item_all menu_item_single"
          :class="route.params.id == 0 ? 'act' : ''"
        >
          <div class="menu_icon icon_zhbd"></div>
          <div class="menu_item_text menu_text">
            <div class="menu_text_tit">综合榜单</div>
            <div class="menu_text_desc">(基础项+创新项)</div>
          </div>
        </router-link>
      </div>
      <template v-if="route_type">
        <div class="menu_item">
          <router-link
            :to="{ path: route_type + '/v2/rank/1-3' }"
            class="menu_item_parent menu_item_all"
            :class="
              menu_base_drive.child_ids.indexOf(route.params.id) > -1 ? 'act' : ''
            "
          >
            <div class="menu_icon icon_rank"></div>
            <div class="menu_text">基础项评测</div>
          </router-link>
          <div class="menu_item_groups">
            <div
              class="menu_item_childs_group"
              :style="{
                height:
                  menu_base_drive.child_ids.indexOf(route.params.id) > -1
                    ? menu_base_drive.child.length * 40 + 2 + 'px'
                    : '0',
              }"
            >
              <div class="menu_item_childs">
                <router-link
                  v-for="(child, ind) in menu_base_drive.child"
                  :key="ind"
                  class="menu_item_child"
                  :class="child.id == route.params.id ? 'act' : ''"
                  :to="{
                    path: route_type + '/v2/rank/' + child.id,
                  }"
                >
                  <div class="menu_item_child_left"></div>
                  <div
                    class="menu_item_child_text"
                    :class="
                      child.name && child.name.length <= 6
                        ? 'menu_item_child_text_left'
                        : ''
                    "
                  >
                    {{ child.name }}
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="menu_item">
          <router-link
            :to="{ path: route_type + '/v2/rank/1-2' }"
            class="menu_item_all menu_item_single"
            :class="route.params.id == '1-2' ? 'act' : ''"
          >
            <div class="menu_icon icon_cxx2"></div>
            <div class="menu_text">创新项评测</div>
          </router-link>
        </div>
      </template>
      <template v-else>
        <div class="menu_item">
          <router-link
            :to="{
              path: route_type + '/v2/rank/0-3',
            }"
            class="menu_item_parent menu_item_all"
            :class="
              menu_base.child_ids.indexOf(route.params.id) > -1 ? 'act' : ''
            "
            @click="changeShow"
          >
            <div class="menu_icon icon_rank"></div>
            <div class="menu_text">基础项评测</div>
          </router-link>
          <div class="menu_item_groups" v-show="show_base">
            <div
              class="menu_item_group"
              v-for="(parent, index) in menu_base.child"
              :key="index"
            >
              <router-link
                :to="{
                  path: route_type + '/v2/rank/' + parent.child_ids[0],
                }"
                class="menu_item_name"
                :style="{
                  'border-bottom': parent.show ? '' : 'solid 1px #E7E7E7',
                }"
                @click="parent.show = !parent.show"
              >
                <div class="menu_item_name_text">{{ parent.name }}</div>
                <div
                  class="menu_item_down"
                  :class="parent.show ? 'act' : ''"
                ></div>
              </router-link>
              <div
                class="menu_item_childs_group"
                :style="{
                  height: parent.show
                    ? parent.child_ids.length * 40 + 2 + 'px'
                    : '0',
                }"
              >
                <div class="menu_item_childs">
                  <router-link
                    v-for="(child, ind) in parent.child"
                    :key="ind"
                    class="menu_item_child"
                    :class="child.id == route.params.id ? 'act' : ''"
                    :to="{
                      path: route_type + '/v2/rank/' + child.id,
                    }"
                  >
                    <div class="menu_item_child_left"></div>
                    <div
                      class="menu_item_child_text"
                      :class="
                        child.name && child.name.length <= 6
                          ? 'menu_item_child_text_left'
                          : ''
                      "
                    >
                      {{ child.name }}
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="menu_item">
          <router-link
            :to="{ path: route_type + '/v2/rank/0-2' }"
            class="menu_item_parent menu_item_all"
            :class="menu_cx.child_ids.indexOf(route.params.id) > -1 ? 'act' : ''"
            @click="show_cx = !show_cx"
          >
            <div class="menu_icon icon_cxx"></div>
            <div class="menu_text">创新项评测</div>
          </router-link>
          <div class="menu_item_groups">
            <div
              class="menu_item_childs_group"
              :style="{
                height:
                  show_cx && menu_cx.child_ids.indexOf(route.params.id) > -1
                    ? menu_cx.child_ids.length * 40 + 2 + 'px'
                    : '0',
              }"
            >
              <div class="menu_item_childs">
                <router-link
                  v-for="(child, ind) in menu_cx.child"
                  :key="ind"
                  class="menu_item_child"
                  :class="child.id == route.params.id ? 'act' : ''"
                  :to="{
                    path: route_type + '/v2/rank/' + child.id,
                  }"
                >
                  <div class="menu_item_child_left"></div>
                  <div
                    class="menu_item_child_text"
                    :class="
                      child.name && child.name.length <= 6
                        ? 'menu_item_child_text_left'
                        : ''
                    "
                  >
                    {{ child.name }}
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="menu_item">
        <router-link
          :to="{ path: route_type + '/v2/overview' }"
          :class="['menu_item_single', platform == 'overview' ? 'act' : '']"
        >
          <div class="menu_icon icon_gnsl"></div>
          <div class="menu_text">功能速览</div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link
          :to="{ path: route_type + '/v2/library' }"
          :class="['menu_item_single', platform == 'library' ? 'act' : '']"
        >
          <div class="menu_icon icon_car"></div>
          <div class="menu_text">车型库</div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link
          :to="{ path: route_type + '/v2/search' }"
          :class="['menu_item_single', platform == 'search' ? 'act' : '']"
        >
          <div class="menu_icon icon_search"></div>
          <div class="menu_text">智能搜索</div>
        </router-link>
      </div>
    </template>
    <!-- <div class="menu_item">
      <router-link
        :to="{ path: route_type+'/setting/ignoreNode' }"
        :class="['menu_item_single', platform == 'setting' ? 'act' : '']"
      >
        <div class="menu_icon icon_config"></div>
        <div class="menu_text">评测项设置</div>
      </router-link>
    </div> -->

    <router-link 
      class="setting_btn"
      :class="platform == 'setting' ? 'act' : ''"
      :to="{ path: route_type+'/setting/ignoreNode' }"
    >
      <div class="menu_icon icon_config"></div>
    </router-link>
  </div>
</template>

<script>
import { reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
export default {
  props: {
    route_type: {
      default: "",
    },
  },
  setup() {
    const show_base = ref(false);
    const show_cx = ref(false);
    const menu_base = ref({
      name: "基础项评测",
      id: "0-3",
      child_ids: [
        "0-3",
        
        "4922",
        "4941",
        "4963",
        "4983",
        "5003",
        "5036",
        "5057",
        "5123",
        "5165",
        "5195",
        
        "4228",
        "4481",
        "4520",
        "4548",

        
        "4575",
        "4600",
        "4685",
        "4760",
        "4779",
        "4828",
        "4861",
        "4880",
      ],
      child: [
        {
          name: "功能维度",
          child: [
            { id: "4922", rank_type: 0, name: "仪表方控" },
            { id: "4941", rank_type: 0, name: "内容生态" },
            { id: "4963", rank_type: 0, name: "座椅空调" },
            { id: "4983", rank_type: 0, name: "座舱安全" },
            { id: "5003", rank_type: 0, name: "硬件智控" },
            { id: "5036", rank_type: 0, name: "空间应用" },
            { id: "5057", rank_type: 0, name: "语音交互" },
            { id: "5123", rank_type: 0, name: "车手互联" },
            { id: "5165", rank_type: 0, name: "车机系统" },
            { id: "5195", rank_type: 0, name: "车载导航" },

          ],
          child_ids: ["4922", "4941", "4963", "4983", "5003", "5036", "5057", "5123", "5165", "5195"],
          show: false,
        },
        {
          name: "性能维度",
          child: [
            { id: "4228", rank_type: 4, name: "智能表现" },
            { id: "4481", rank_type: 4, name: "易用性" },
            { id: "4520", rank_type: 4, name: "外观" },
            { id: "4548", rank_type: 4, name: "可信赖感" },
          ],
          child_ids: ["4228", "4481", "4520", "4548"],
          show: false,
        },
        {
          name: "旅途维度",
          child: [
            { id: "4575", rank_type: 5, name: "准备出发" },
            { id: "4600", rank_type: 5, name: "车中落座" },
            { id: "4685", rank_type: 5, name: "车辆行驶" },
            { id: "4760", rank_type: 5, name: "特殊情况" },
            { id: "4779", rank_type: 5, name: "停车小憩" },
            { id: "4828", rank_type: 5, name: "再次出行" },
            { id: "4861", rank_type: 5, name: "车辆到达" },
            { id: "4880", rank_type: 5, name: "驾乘回忆" },
          ],
          child_ids: [
            "4575",
            "4600",
            "4685",
            "4760",
            "4779",
            "4828",
            "4861",
            "4880",
          ],
          show: false,
        },
      ],
    });
    const menu_cx = reactive({
      name: "创新维度",
      id: "0-2",
      child: [
        { id: "1", rank_type: 2, name: "数字化创新" },
        { id: "2", rank_type: 2, name: "交互功能创新" },
        { id: "3", rank_type: 2, name: "座舱环境创新" },
      ],
      child_ids: ["0-2", "1", "2", "3"],
    });

    const menu_base_drive = ref({
      name: "功能维度",
      id: "1-3",
      child: [
        { id: "3739", rank_type: 0, name: "行车场景" },
        { id: "3865", rank_type: 0, name: "高速领航辅助驾驶" },
        { id: "3906", rank_type: 0, name: "DMS监测" },
        { id: "3916", rank_type: 0, name: "自动泊车场景" },
      ],
      child_ids: ["1-3", "3739", "3865", "3906", "3916"],
    });
    const route = useRoute();
    let platform = ref("");
    watch(
      () => route.path,
      (new_path, old_path) => {
        if (new_path != old_path) {
          getPlatformFn(new_path);
        }
      }
    );
    const getPlatformFn = (new_path) => {
      if (new_path.indexOf("rank") > -1) {
        platform.value = route.params.id;
        if (new_path.indexOf("drive" == -1)) {
          if (menu_base.value.child_ids.indexOf(route.params.id) > -1) {
            show_base.value = true;
            menu_base.value.child.forEach((parent, ind) => {
              if (parent.child_ids.indexOf(route.params.id) > -1) {
                menu_base.value.child[ind].show = true;
              } else {
                menu_base.value.child[ind].show = false;
              }
            });
          } else {
            show_base.value = false;
            show_cx.value = true;
          }
        } else {
          platform.value = "drive" + route.params.id;
        }
      }else if(new_path.indexOf("service") > -1){
        if(new_path.indexOf('downloads')>-1){
          platform.value = "downloads";
        }
        if(new_path.indexOf('sales')>-1){
          platform.value = "sales";
        }
        if(new_path.indexOf('ota')>-1){
          platform.value = "ota";
        }
      } else {
        if (new_path.indexOf("library") > -1) {
          platform.value = "library";
        } else if (new_path.indexOf("overview") > -1) {
          platform.value = "overview";
        } else if (new_path.indexOf("search") > -1 && new_path.indexOf("/analyse/search") == -1) {
          platform.value = "search";
        } else if (new_path.indexOf("setting") > -1) {
          platform.value = "setting";
        }
        show_base.value = false;
        show_cx.value = false;
      }
    };
    getPlatformFn(route.path);
    const changeShow = () => {
      show_base.value = !show_base.value;
      menu_base.value.child.forEach((parent, ind) => {
        if (parent.child_ids.indexOf(route.params.id) > -1) {
          menu_base.value.child[ind].show = true;
        } else {
          menu_base.value.child[ind].show = false;
        }
      });
    };
    return {
      show_cx,
      platform,
      menu_base,
      menu_base_drive,
      menu_cx,
      route,
      show_base,
      changeShow,
    };
  },
};
</script>

<style lang="less" scoped>
.slider {
  width: 185px;
  padding-top: 25px;
  padding-bottom: 100px;
  background: #fff;
  min-height: 100%;
  position: relative;
  .menu_item {
    padding-top: 20px;
    .menu_item_all,
    .menu_item_single {
      display: flex;
      align-items: center;
      height: 50px;
      padding-left: 25px;
      position: relative;
      cursor: pointer;
      .menu_icon {
        width: 25px;
        height: 25px;
        &.icon_zhbd {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/zh1_20230111.svg)
            no-repeat center center;
          background-size: 21px;
        }
        &.icon_rank {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/jc1_20230111.svg)
            no-repeat center center;
          background-size: 21px;
        }
        &.icon_cxx,
        &.icon_cxx2 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cx1_20230111.svg)
            no-repeat center center;
          background-size: 18px;
        }
        &.icon_car {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cxk1_20230111.svg)
            no-repeat center center;
          background-size: 23px;
        }
        &.icon_gnsl {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gn1_20230111.svg)
            no-repeat center center;
          background-size: 23px;
        }
        &.icon_search {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ss1_20230111.svg)
            no-repeat center center;
          background-size: 20px;
        }
        &.icon_config {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/config_20230111.svg)
            no-repeat center center;
          background-size: 22px;
        }
        &.icon_yjbg {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/yjbg_20230215.svg)
            no-repeat center center;
          background-size: 20px;
        }
        &.icon_xlph {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/xlph_20230215.svg)
            no-repeat center center;
          background-size: 22px;
        }
        &.icon_ota {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ota_20230301.svg)
            no-repeat center center;
          background-size: 20px;
        }
      }
      .menu_text {
        width: 100px;
        font-size: 16px;
        color: #404e5b;
        padding-left: 10px;
      }
      .menu_item_text {
        width: 105px;
        .menu_text_tit {
          font-size: 16px;
          color: #404e5b;
          line-height: 21px;
        }
        .menu_text_desc {
          font-size: 12px;
          color: #404e5b;
          line-height: 16px;
        }
      }
    }
    .menu_item_all.act {
      .menu_text {
        font-weight: bold;
      }
    }
    .menu_item_single.act {
      position: relative;
      background: #1fbcbf;
      margin-left: 16px;
      padding-left: 9px;
      width: 163px;
      &::before {
        content: "";
        width: 6px;
        height: 49px;
        background: #1fbcbf;
        border-radius: 0 2px 2px 0;
        position: absolute;
        left: -16px;
        top: 0;
      }
      
      .menu_text {
        color: #fff;
        font-weight: bold;
      }
      .menu_text_tit,
      .menu_text_desc {
        color: #fff;
      }
      .menu_text_tit {
        font-weight: bold;
      }
    }
    .menu_item_all.act,.menu_item_single.act{
      .menu_icon {
        &.icon_rank {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/jc2_20230111.svg)
            no-repeat center center;
          background-size: 21px;
        }
        &.icon_zhbd {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/zh2_20230111.svg)
            no-repeat center center;
          background-size: 21px;
        }
        &.icon_cxx {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cx2_20230111.svg)
            no-repeat center center;
          background-size: 18px;
        }
        &.icon_cxx2 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cx2_20230110.svg)
            no-repeat center center;
          background-size: 18px;
        }
        &.icon_car {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cxk2_20230111.svg)
            no-repeat center center;
          background-size: 23px;
        }
        &.icon_gnsl {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gn2_20230111.svg)
            no-repeat center center;
          background-size: 23px;
        }
        &.icon_search {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ss2_20230111.svg)
            no-repeat center center;
          background-size: 20px;
        }
        // &.icon_config {
        //   background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/config2_20230111.svg)
        //     no-repeat center center;
        //   background-size: 22px;
        // }
        &.icon_yjbg {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/yjbg2_20230215.svg)
            no-repeat center center;
          background-size: 20px;
        }
        &.icon_xlph {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/xlph2_20230215.svg)
            no-repeat center center;
          background-size: 22px;
        }
        &.icon_ota {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ota2_20230301.svg)
            no-repeat center center;
          background-size: 20px;
        }
      }
    }
    .menu_item_single.menu_item_right{
        padding-left: 36px;
        &.act{
          padding-left: 20px;
        }
    }
    .menu_item_groups {
      cursor: pointer;
      overflow: hidden;
      transition: height 1s;
      &.hide {
        height: 0;
      }
      .menu_item_group {
        width: 100%;
        .menu_item_name {
          width: 150px;
          height: 50px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          padding-left: 32px;
          .menu_item_name_text {
            padding-left: 10px;
            font-size: 15px;
            color: #36474f;
          }
          .menu_item_down {
            width: 10px;
            height: 10px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/down_20221226.png)
              no-repeat left center;
            background-size: 10px;
            margin-left: 8px;
            transition: all 500ms;
            &.act {
              transform: rotateZ(180deg);
            }
          }
        }
      }
    }
    .menu_item_childs_group {
      transition: height 500ms;
      overflow: hidden;
    }
    .menu_item_childs {
      width: 154px;
      background: #fbfbfb;
      border-radius: 4px;
      border: 1px solid #dcdbdb;
      margin: 0 auto;
      .menu_item_child {
        display: flex;
        align-items: center;
        height: 40px;
        padding-left: 1px;
        border-bottom: solid 1px #dcdbdb;
        padding-left: 16px;
        &:nth-last-child(1) {
          border: none;
        }
        .menu_item_child_left {
          width: 6px;
          height: 6px;
          background: #d8d8d8;
          border-radius: 3px;
          flex-shrink: 0;
        }
        .menu_item_child_text {
          width: 163px;
          height: 40px;
          line-height: 40px;
          border-radius: 2px;
          font-size: 12px;
          color: #888888;
          padding-left: 19px;
          &.menu_item_child_text_left {
            text-align: left;
            font-size: 13px;
          }
        }
        &.act {
          .menu_item_child_left {
            background: #1fbcbf;
          }
          .menu_item_child_text {
            color: #404e5b;
            font-weight: bold;
            position: relative;
          }
        }
      }
    }
  }
  .setting_btn{
    width: 100%;
    height: 50px;
    border-top: solid 1px #E0E0E0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left:0;
    .icon_config{
      width: 30px;
      height: 30px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/config_20230111.svg) no-repeat center center;
      background-size: 22px;
    }
    // &.act{
    //   background: #1fbcbf;
    //   .icon_config {
    //     width: 30px;
    //     height: 30px;
    //     background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/config2_20230111.svg) no-repeat center center;
    //     background-size: 22px;
    //   }
    // }
  }
}
</style>